import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";
import {BaseMetadataModel} from "../../../../infrastructure/models/base-metadata-model";

export class TvNetworkImageRequestParams extends ImageRequestParams {

  constructor(tvNetworkId: Number, metaData: BaseMetadataModel,width: Number = 40, height: Number = 12) {
    super({resourceName: 'TVNetworks', metaData, width, height});

    this.id = tvNetworkId;
  }

  toString(): String {
    return super.toString() + '/' + this.id;
  }
}
